import React from "react";

import Add from "../actions/icons/Add";
import Tab from "./Tab";
import { NewTabButton, TabsContainer, TabsGroupContainer } from "./styles";
import { useCardsStore } from "../../../../stores/use-cards-store";
import { CARDS_PROP } from "../../../../optics/components/drawers/settings/features/cards/defaults";

const Tabs = ({ tabs, isPreview = false, isEditable = false }) => {
  const {
    data,
    updateCardsTabs,
    cardsTab,
    setCardsTab,
    removeCards,
    updateCardsConfig,
  } = useCardsStore((state) => ({
    data: state.data,
    updateCardsTabs: state.updateCardsTabs,
    cardsTab: state.cardsTab,
    setCardsTab: state.setCardsTab,
    removeCards: state.removeCards,
    updateCardsConfig: state.updateCardsConfig,
  }));

  return (
    <TabsGroupContainer>
      <TabsContainer>
        {tabs.map((tab) => (
          <Tab
            tabs={tabs}
            isEditable={isEditable}
            isPreview={isPreview}
            label={tab.text}
            isSelected={cardsTab.id === tab.id}
            onTabClick={() => setCardsTab(tab)}
            onDeleteClick={() => {
              if (tabs.length > 1) {
                const newTabs = tabs.filter((item) => item.id !== tab.id);
                const newCards = data.filter(
                  ({ card }) => card.tabId !== tab.id
                );
                removeCards(newCards);
                updateCardsTabs(newTabs);
                if (!!newTabs.length) return setCardsTab(newTabs.at(-1));
              } else {
                updateCardsConfig({
                  key: CARDS_PROP.HAS_TABS,
                  value: false,
                });
              }
            }}
            onReorderClick={({ direction }) => {
              const currentIndex = tabs.findIndex((item) => item.id === tab.id);
              const newIndex =
                direction === "right" ? currentIndex + 1 : currentIndex - 1;

              if (newIndex < 0 || newIndex >= tabs.length) return;

              const newTabs = [...tabs];
              [newTabs[currentIndex], newTabs[newIndex]] = [
                newTabs[newIndex],
                newTabs[currentIndex],
              ];

              updateCardsTabs(newTabs);
            }}
            movePermissions={{
              left: tabs.findIndex((item) => item.id === tab.id) > 0,
              right:
                tabs.findIndex((item) => item.id === tab.id) < tabs.length - 1,
            }}
          />
        ))}

        {!isPreview && (
          <NewTabButton
            onClick={() => {
              const newTab = {
                id: crypto.randomUUID(),
                text: "",
                icon: "",
              };

              updateCardsTabs([...tabs, newTab]);
              setCardsTab(newTab);
            }}
          >
            <Add />
          </NewTabButton>
        )}
      </TabsContainer>
    </TabsGroupContainer>
  );
};

export default Tabs;
